@if (isOpen) {
  <div class="confirm-overlay" [class.open]="isOpen">
    <div class="confirm-backdrop" (click)="close(false)"></div>
    <div class="confirm-dialog">
      <div class="dialog-icon" [ngClass]="data.type || 'warning'">
        <hugeicons-icon [icon]="getIcon()" [size]="48" color="currentColor"></hugeicons-icon>
      </div>
      <div class="dialog-content">
        <h3 class="dialog-title">{{ data.title }}</h3>
        <p class="dialog-message">{{ data.message }}</p>
      </div>
      <div class="dialog-actions">
        <button class="btn btn-outline" (click)="close(false)">
          {{ data.cancelText || 'Cancel' }}
        </button>
        <button class="btn" [ngClass]="getConfirmButtonClass()" (click)="close(true)">
          {{ data.confirmText || 'Confirm' }}
        </button>
      </div>
    </div>
  </div>
}